<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc"><h2>Contents</h2>
<ol class="bbb-rw" epub:type="list"><li><a href="#/Text/cover">Cover</a></li>
<li><a href="#/Text/s001BookTitlePage01">Title Page</a></li>
<li><a href="#/Text/s002Copyright01">Copyright</a></li>
<li><a href="#/Text/s004Dedication01">Dedication</a></li>
<li><a href="#/Text/s005Chapter001">Chapter One</a></li>
<li><a href="#/Text/s006Chapter002">Chapter Two</a></li>
<li><a href="#/Text/s007Chapter003">Chapter Three</a></li>
<li><a href="#/Text/s008Chapter004">Chapter Four</a></li>
<li><a href="#/Text/s009Chapter005">Chapter Five</a></li>
<li><a href="#/Text/s010Chapter006">Chapter Six</a></li>
<li><a href="#/Text/s011Chapter007">Chapter Seven</a></li>
<li><a href="#/Text/s012Chapter008">Chapter Eight</a></li>
<li><a href="#/Text/s013Chapter009">Chapter Nine</a></li>
<li><a href="#/Text/s014Chapter010">Chapter Ten</a></li>
<li><a href="#/Text/s015Chapter011">Chapter Eleven</a></li>
<li><a href="#/Text/s016Chapter012">Chapter Twelve</a></li>
<li><a href="#/Text/s017Chapter013">Chapter Thirteen</a></li>
<li><a href="#/Text/s018Chapter014">Chapter Fourteen</a></li>
<li><a href="#/Text/s019Chapter015">Chapter Fifteen</a></li>
<li><a href="#/Text/s020Chapter016">Epilogue</a></li>
<li><a href="#/Text/s021Epilogue001">Author’s Historical Note</a></li>
<li><a href="#/Text/s022TeaserOpener01">An Excerpt from IF THE DUKE DEMANDS</a></li>
<li><a href="#/Text/s024AboutTheAuthor01">About the Author</a></li>
<li><a href="#/Text/s025AdCard01">Also by Anna Harrington</a></li>
<li><a href="#/Text/s026FrontSales01">Praise for Anna Harrington’s Novels</a></li>
<li><a href="#/Text/s027BackAd01">Fall in Love with Forever Romance</a></li>
<li><a href="#/Text/s028Appendix01">Newsletters</a></li>
</ol></nav>
<nav class="ccc-rw" epub:type="landmarks"><h2>
    Navigation
   </h2>
<ol epub:type="list"><li>
<a epub:type="frontmatter" href="#/Text/s004Dedication01#Dedication1">
      Begin Reading
     </a>
</li>
<li>
<a epub:type="toc" href="#/Text/TOC">
      Table of Contents
     </a>
</li>
</ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?15464679